module.exports = __webpack_public_path__ + "img/GAME_SWEEPLEAVES.062d36b9.png";